import { oc } from "@orpc/contract";
import { z } from "zod";

/** Whether the API answers and reaches its database, and what time the server thinks it is. */
export const HealthStatus = z.object({
	status: z.enum(["ok", "degraded"]),
	database: z.enum(["ok", "unavailable"]),
	/** The server's clock (Effect `Clock`), ISO 8601 in UTC. */
	time: z.iso.datetime(),
});
export type HealthStatus = z.infer<typeof HealthStatus>;

export const HealthContract = {
	check: oc.route({ method: "GET", path: "/health" }).output(HealthStatus),
};
